/* AlloSwitch – Achat immédiat. Le formulaire Shopify reste la source des variantes, quantités et propriétés. */
(function () {
  'use strict';

  function rootPath() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.endsWith('/') ? root : root + '/';
  }

  function attachBuyNow() {
    document.querySelectorAll('[data-allo-buy-now]').forEach(function (button) {
      if (button.dataset.ready === 'true') return;
      button.dataset.ready = 'true';

      var panel = button.closest('.allo-choice2-panel');
      if (!panel) return;
      var error = panel.querySelector('[data-allo-buy-now-error]');

      function nativeForm() {
        return panel.querySelector('product-form-component form[data-type="add-to-cart-form"]');
      }

      function sync() {
        var form = nativeForm();
        var primary = form && form.querySelector('.add-to-cart-button');
        var variant = form && form.querySelector('[name="id"]');
        var blocked = button.dataset.loading === 'true' || !primary || primary.disabled || !variant || !variant.value;
        if (button.disabled !== Boolean(blocked)) button.disabled = Boolean(blocked);
      }

      var observer = new MutationObserver(sync);
      observer.observe(panel, {subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'value']});
      document.addEventListener('change', sync);
      document.addEventListener('shopify:section:load', sync);
      sync();

      button.addEventListener('click', async function () {
        sync();
        if (button.disabled) return;

        var form = nativeForm();
        if (!form) return;
        if (!form.reportValidity()) return;
        if (error) {
          error.hidden = true;
          error.textContent = '';
        }

        var data = new FormData(form);
        var variantId = String(data.get('id') || '');
        var quantity = Number(data.get('quantity') || 1);
        if (!/^\d+$/.test(variantId) || !Number.isInteger(quantity) || quantity < 1) {
          if (error) {
            error.textContent = 'Veuillez sélectionner une variante et une quantité valides.';
            error.hidden = false;
          }
          return;
        }

        data.set('quantity', String(quantity));
        ['form_type', 'utf8', 'product-id', 'section-id'].forEach(function (key) { data.delete(key); });

        button.dataset.loading = 'true';
        button.textContent = 'Redirection vers le paiement…';
        sync();

        try {
          var response = await fetch(rootPath() + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json' },
            body: data
          });
          if (!response.ok) {
            var details = await response.json().catch(function () { return {}; });
            throw new Error(details.description || details.message || 'Produit indisponible dans cette quantité.');
          }
          window.location.assign(rootPath() + 'checkout');
        } catch (e) {
          if (error) {
            error.textContent = e && e.message ? e.message : "L'achat n'a pas pu être lancé. Veuillez réessayer.";
            error.hidden = false;
          }
          button.dataset.loading = 'false';
          button.textContent = 'Acheter maintenant';
          sync();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachBuyNow);
  } else {
    attachBuyNow();
  }
  document.addEventListener('shopify:section:load', attachBuyNow);
})();
